const SELECTOR_TOGGLE = '.dropdown-toggle';
const SELECTOR_BUTTON = '#county-list-menu-button';
const SELECTOR_MENU = '.dropdown-menu';

export function activateDropdown(element) {
  const toggle = element.querySelector(SELECTOR_TOGGLE);
  const menu = element.querySelector(SELECTOR_MENU);

  function onMouseover() {
    // console.log('toggled')
    if (menu.hasAttribute('hidden')) {
      document
        .querySelectorAll(SELECTOR_MENU)
        .forEach((e) => e.setAttribute('hidden', ''));
      toggle.setAttribute('aria-expanded', 'true');
      menu.removeAttribute('hidden');
    } else {
      toggle.setAttribute('aria-expanded', 'false');
      menu.setAttribute('hidden', '');
    }
  }

  function onMouseout() {
    if (!menu.hasAttribute('hidden')) {
      toggle.setAttribute('aria-expanded', 'false');
      menu.setAttribute('hidden', '');
    }
  }

  function toggleFunctionOnClick() {
    if (menu.hasAttribute('hidden')) {
      onMouseover();
    } else {
      onMouseout();
    }
  }

  toggle.addEventListener('mouseover', onMouseover);
  toggle.addEventListener('mouseout', onMouseout);
  document
    .querySelector(SELECTOR_BUTTON)
    .addEventListener('click', toggleFunctionOnClick);
}
